import { fileFormToUpdate } from '@/_containers';
import { currencyInput } from '@/_schemas/generic';
import { statusToStr, strToStatus } from '@/_schemas/status-input';

import type { PartnerFormSchema, PartnerQuerySchema } from './schemas';

export function partnerQueryToForm(data: PartnerQuerySchema) {
  return {
    ...data,
    name: data.name ?? '',
    website: data.website ?? '',
    email: data.email ?? '',
    code: data.code ?? '',
    logo: data.logo,
    logo_light: data.logo_light,
    icon: data.icon,
    status: strToStatus(data.status),
    // Termination & Notice Tracking
    termination_notice_date: data.termination_notice_date ?? null,
    required_notice_days: data.required_notice_days ?? null,
    override_termination_date: data.override_termination_date ?? null,
    termination_extension_days: data.termination_extension_days ?? null,
    calculated_termination_date: data.calculated_termination_date ?? null,
    final_termination_date: data.final_termination_date ?? null,
    // Tail Commission Settings
    tail_enabled: data.tail_enabled ?? false,
    tail_percentage: data.tail_percentage ?? null,
    tail_duration_months: data.tail_duration_months ?? null,
    tail_flat_monthly_payout: currencyInput.queryToFormConverter(data.tail_flat_monthly_payout),
    tail_start_month: data.tail_start_month ?? '',
    // Transition Period Tail Settings
    transition_tail_enabled: data.transition_tail_enabled ?? false,
    transition_tail_percentage: data.transition_tail_percentage ?? null,
    transition_tail_duration_months: data.transition_tail_duration_months ?? null,
    transition_tail_start_month: data.transition_tail_start_month ?? null,
  };
}

export function partnerFormToMutation({
  status,
  logo,
  logo_light,
  icon,
  tail_flat_monthly_payout,
  ...rest
}: PartnerFormSchema) {
  return {
    ...rest,
    status: statusToStr(status),
    logo: fileFormToUpdate(logo),
    logo_light: fileFormToUpdate(logo_light),
    icon: fileFormToUpdate(icon),
    tail_flat_monthly_payout: currencyInput.formToUpdateConverter(tail_flat_monthly_payout),
  };
}
